import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useGlobalSettings } from 'providers';

/**
 * Keeps the form `app` field in sync with the globally selected application
 * (managed in the side menu / persisted to localStorage). When the global
 * application changes, the optional `onAppChange` callback runs so the form can
 * reset any app-dependent selections.
 */
const useSyncGlobalApp = (onAppChange?: () => void): void => {
  const { selectedApp } = useGlobalSettings();
  const { setValue, getValues } = useFormContext();

  useEffect(() => {
    if (!selectedApp || getValues('app') === selectedApp) return;

    setValue('app', selectedApp, { shouldValidate: true, shouldDirty: true });
    onAppChange?.();
  }, [selectedApp, setValue, getValues, onAppChange]);
};

export default useSyncGlobalApp;
